<app-qstnhdr-add  [iHeader]='header'>
</app-qstnhdr-add>